import release from './release';
import releaseAction from './release-action';
import settings from './settings';

export const routes = {
  settings,
  release,
  'release-action': releaseAction,
};
